import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import ImageDataService from '../../services/ImageDataService';
import AuthService from '../../services/AuthService';
import Login from '../../pages/Login';

export default class GalleryCreateImg extends Component {
    constructor() {
        super()
        this.state = {
            selectedFile: null,
            haveRoleOfAdminOrMod:false,
            imageName: '',
            description:'',
            album:''
        };
        this.onChange = this.onChange.bind(this);
        this.onSubmitImage = this.onSubmit.bind(this);

    }

    componentDidMount() {
        this.refreshGalleryCreate();

    }
    refreshGalleryCreate = () => {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        if (loggedInUser) {
            if (whatRole === ('MODERATOR') || whatRole === ('ADMIN')) {
                this.setState({ haveRoleOfAdminOrMod: true });
            }
        }      
        }
    


    onChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }


    onSubmitImage(event) {
        event.preventDefault()
    }




    fileSelectedHandler = event => {
        this.setState({
            selectedFile: event.target.files[0]
        })
    }

    fileUpalodHandler = () => {
        const fileData = new FormData();
        fileData.append('file', this.state.selectedFile)
        fileData.append('imageName',this.state.imageName);
        fileData.append('description',this.state.description);
        fileData.append('album',this.state.album);
        fileData.set('imageCeatedBy',AuthService.getCurrentUser().id);
        this.createImage(fileData);
    }

    createImage(data) {
        return ImageDataService.createImage(data).then(res => {
            alert("Uploaded Successfully !");
             window.open('/family-gallery',"_self");
        }).catch(err => {
        })
    }


    render() {

   
        return (
            <div>
                {!this.state.haveRoleOfAdminOrMod ? 
                <div>
                <Login></Login>
                </div> :
            <div className="top-level-page-main album-create">
  <div className="member-view-profile">
  <div className="member-profile-details">
  <form onSubmit={this.onSubmitImage}>
                                 <div className="form-group-create">
                                        <h5> Image Name </h5> 
                                        <input
                                     
                                        type="text"
                                            name="imageName" placeholder="Image-Name"
                                            value={this.state.imageName}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                    <div className="form-group-create">
                                        <h5> Description  </h5> 
                                        <input
                                       
                                        type="text"
                                            name="description" placeholder="Description"
                                            value={this.state.description}
                                            onChange={this.onChange}
                                        />
                                    </div>

                                    <div className="form-group-create">
                                        <h5> Album </h5> 
                                        <input

                                        type="text"
                                            name="album" placeholder="album"
                                            value={this.state.album}
                                            onChange={this.onChange}
                                        />
                                    </div>


                    </form>
                    <div className="actionsProfile">          
<input type='file' onChange={this.fileSelectedHandler} />                    
<button className="btn" onClick={this.fileUpalodHandler}> Create Image </button>
</div>
<button className="btn" onClick={this.props.history.goBack}> للعودة  </button>
  
 
      </div>
  </div>
        </div>
    } </div>

        )
    }
}
